import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  grid-gap: 4px;
  height: 26px;
  align-items: flex-end;
  .score {
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.cflowerBlue};
    margin-left: 4px;
    opacity: 0.7;
  }
`;

export const Bar = styled.div<{ $height: number; $isActive: boolean }>`
  border-radius: 4px;
  width: 6px;
  position: relative;
  overflow: hidden;
  background: ${({ theme, $isActive }) => ($isActive ? theme.colors.gradientVertical : theme.colors.cflowerBlue)};
  height: ${({ $height }) => $height}%;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.7)};
`;
